import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * DO NOT EDIT THIS FILE DIRECTLY.
 *
 * This file is automatically generated by running yarn icons:generate.
 */

import * as React from 'react';

function IconFiletypeBlank24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.243 12.703l-3.022-.86a1.224 1.224 0 11.793-2.313L11 10.735l-.197-3.442A1.224 1.224 0 0112.025 6h.058c.703 0 1.262.59 1.222 1.293l-.198 3.537 2.872-1.17c.66-.269 1.409.08 1.627.76l.005.013a1.224 1.224 0 01-.836 1.554l-3.1.865 2.047 2.605a1.224 1.224 0 01-.25 1.752l-.044.031c-.575.411-1.38.25-1.752-.35l-1.77-2.856-1.755 2.762a1.224 1.224 0 01-1.723.355l-.02-.014a1.224 1.224 0 01-.27-1.77l2.105-2.664z",
    fill: "currentColor"
  }));
}

var ForwardRef = React.forwardRef(IconFiletypeBlank24);
var MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;